// From: https://blog.bitscry.com/2018/08/17/getting-and-setting-url-parameters-with-javascript/
export function setUrlParameter(url, key, value) {
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);
    let isEmptyValue = typeof value === 'undefined' || value === null || value === '';
    let workingUrl = url;

    // Process hashtag
    let hash = '';
    if (workingUrl.indexOf('#') > -1) {
        const urlHashParts = workingUrl.split('#');
        hash = urlHashParts[1];
        workingUrl = urlHashParts[0];
    }

    const urlQueryParts = workingUrl.split('?');

    let baseUrl = urlQueryParts[0],
        newParam = key + '=' + value,
        params = '?' + newParam;

    let urlQueryString = '';
    // if there are no query strings, leave urlQueryString empty
    if (urlQueryParts[1] !== undefined)
        urlQueryString = '?' + urlQueryParts[1];

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
        let updateRegex = new RegExp('([\?&])' + key + '[^&]*');
        let removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

        if (isEmptyValue) { // Remove param if value is empty
            params = urlQueryString.replace(removeRegex, '$1');
            params = params.replace(/[&;]$/, '');

        } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
            params = urlQueryString.replace(updateRegex, '$1' + newParam);

        } else { // Otherwise, add it to end of query string
            params = urlQueryString + '&' + newParam;
        }
    } else if (isEmptyValue) {
        // Don't add empty params to empty urlQueryString
        params = '';
    }

    // No parameter was set so we don't need the question mark
    params = params === '?' ? '' : params;

    // Add hash if presented
    params += hash.length > 0 ? `#${hash}` : '';

    return baseUrl + params;
}
